import {api} from '@/lib/api';
import {OfferWithDetails, UserOfferPurchase, OfferCheckoutResponse} from './offer-interfaces';

export async function getOrganizationOffers(organizationId: string): Promise<OfferWithDetails[]> {
    // For now, we'll need to fetch from PocketBase directly since we don't have a backend endpoint
    // This would be replaced with a proper API call once the backend endpoint is ready
    // const xhr = await api.get<{offers: OfferWithDetails[]}>(`/offers/organization/${organizationId}`);
    // return xhr.data.offers;

    // Temporary: return empty array until backend endpoint is ready
    // Return a resolved promise instead of throwing an error
    return Promise.resolve([]);
}

export async function getUserPurchases(): Promise<UserOfferPurchase[]> {
    try {
        const xhr = await api.get<{purchases: UserOfferPurchase[]}>('/app-data/purchases');
        return xhr.data.purchases;
    } catch (error) {
        // If the endpoint doesn't exist or there's an error, return empty array
        console.warn('Failed to fetch user purchases:', error);
        return [];
    }
}

export async function createOfferCheckout(
    offerId: string,
    paymentProvider?: string
): Promise<OfferCheckoutResponse> {
    const url = paymentProvider
        ? `/offers/${offerId}/checkout/${paymentProvider}`
        : `/offers/${offerId}/checkout`;

    const xhr = await api.post<OfferCheckoutResponse>(url);
    return xhr.data;
}

export interface FinalizePaymentResponse {
    status: 'completed' | 'pending' | 'failed';
    message: string;
    purchaseId: string;
}

export async function finalizeOfferPayment(
    offerId: string,
    purchaseId: string,
    token?: string,
    sessionId?: string
): Promise<FinalizePaymentResponse> {
    const params = new URLSearchParams({
        purchaseId,
        ...(token && { token }),
        ...(sessionId && { sessionId })
    });

    const xhr = await api.get<FinalizePaymentResponse>(
        `/offers/${offerId}/finalize-payment?${params.toString()}`
    );
    return xhr.data;
}